// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d79bf5f9a967be0bea695cbd527689de68daf55d/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};